import { useMemo } from "react";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { BUTTON_WIDTH, CONTAINER_PADDING, MAX_VISIBLE_BUTTONS, MAX_VISIBLE_BUTTONS_NEW_LAYOUT, } from "../constants/constants";

export default function useButtonGroupContainerStyle(visibleButtonsCount: number, reservedVisibleButtonCount: number = 0, reservedExtraWidth: number = 0): React.CSSProperties {
    return useMemo(() => {
        const effectiveCount = Math.max(1, visibleButtonsCount);
        // Buttons that reserve a header slot (e.g. the Rewards button) can render wider than a
        // standard icon button. `reservedExtraWidth` is the summed per-button overage (each wide
        // button's width minus BUTTON_WIDTH), so the container reserves exactly the room those
        // buttons need regardless of how wide each one is.
        const width = effectiveCount * BUTTON_WIDTH + CONTAINER_PADDING + reservedExtraWidth;
        const baseMaxVisibleButtons = isGlobalFeatureEnabled("fwk-header-sync-button-and-cleanup")
            ? MAX_VISIBLE_BUTTONS_NEW_LAYOUT
            : MAX_VISIBLE_BUTTONS;
        // Reserve extra visible slots for buttons that opt in via `addsHeaderSlot`, so they stay
        // pinned in the header instead of collapsing into the overflow menu when visible.
        const maxVisibleButtons = baseMaxVisibleButtons + reservedVisibleButtonCount;
        
        return {
            flex: `0 2 ${width}px`, // No grow, can shrink, base width
            minWidth: `${BUTTON_WIDTH}px`, // Minimum width for at least one button
            maxWidth: `${maxVisibleButtons * BUTTON_WIDTH + CONTAINER_PADDING + reservedExtraWidth}px`, // Maximum based on button count plus reserved wide-button room
        };
    }, [visibleButtonsCount, reservedVisibleButtonCount, reservedExtraWidth]);
}
